import { Component } from '@theme/component';

const dutchTime = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Europe/Amsterdam', year: 'numeric', month: '2-digit', day: '2-digit',
  weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
});

export function dutchHolidays(year) {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = (h + l - 7 * m + 114) % 31 + 1;
  const easter = Date.UTC(year, month - 1, day);
  const kingDay = new Date(Date.UTC(year, 3, 27)).getUTCDay() === 0 ? '04-26' : '04-27';
  return new Set([
    `${year}-01-01`, `${year}-${kingDay}`, `${year}-05-05`, `${year}-12-25`, `${year}-12-26`,
    ...[-2, 0, 1, 39, 49, 50].map(offset => new Date(easter + offset * 86400000).toISOString().slice(0, 10))
  ]);
}

export function isPhoneOpen(date = new Date()) {
  const parts = Object.fromEntries(dutchTime.formatToParts(date).map(part => [part.type, part.value]));
  if (parts.weekday === 'Sat' || parts.weekday === 'Sun') return false;
  if (dutchHolidays(Number(parts.year)).has(`${parts.year}-${parts.month}-${parts.day}`)) return false;
  const minutes = Number(parts.hour) * 60 + Number(parts.minute);
  return (minutes >= 600 && minutes < 720) || (minutes >= 840 && minutes < 1020);
}

class MartGuardPhoneAvailability extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.initialize();
  }

  updatedCallback() {
    super.updatedCallback();
    this.initialize();
  }

  disconnectedCallback() {
    this.cleanup();
    super.disconnectedCallback();
  }

  cleanup() {
    clearTimeout(this.timer);
    this.controller?.abort();
    this.observer?.disconnect();
  }

  initialize() {
    this.cleanup();
    this.controller = new AbortController();
    const refresh = () => {
      if (!this.isConnected) return;
      const open = isPhoneOpen();
      const state = open ? 'open' : 'closed';
      const label = open ? this.dataset.openLabel : this.dataset.closedLabel;
      for (const link of document.querySelectorAll('a[href^="tel:"]')) {
        const phone = link.getAttribute('href').replace(/[^0-9]/g, '');
        if (phone !== '31598381001' && phone !== '0598381001') continue;
        let indicator = link.querySelector('.mg-phone-status');
        if (!indicator) {
          indicator = document.createElement('span');
          indicator.className = 'mg-phone-status';
          indicator.setAttribute('role', 'img');
          (link.querySelector('strong') || link).prepend(indicator);
        }
        if (indicator.dataset.state !== state) indicator.dataset.state = state;
        if (indicator.getAttribute('aria-label') !== label) indicator.setAttribute('aria-label', label);
        if (indicator.title !== label) indicator.title = label;
      }
      clearTimeout(this.timer);
      this.timer = setTimeout(refresh, 60100 - Date.now() % 60000);
    };
    this.observer = new MutationObserver(records => {
      const phoneChanged = records.some(record => record.target instanceof Element && record.target.closest('a[href^="tel:"]')
        || [...record.addedNodes].some(node => node instanceof Element && (node.matches('a[href^="tel:"]') || node.querySelector('a[href^="tel:"]'))));
      if (phoneChanged) refresh();
    });
    this.observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('visibilitychange', refresh, { signal: this.controller.signal });
    window.addEventListener('pageshow', refresh, { signal: this.controller.signal });
    refresh();
  }
}

if (!customElements.get('mg-phone-availability')) customElements.define('mg-phone-availability', MartGuardPhoneAvailability);
